import { Dispatch } from 'react';
import { axiosInstance } from '../../utils/axios';
import { GET_ALL_TAGS } from './types';

export const getAllTags =
  () =>
  async (
    dispatch: Dispatch<{
      type: string;
      payload: any;
    }>
  ) => {
    try {
      const res = await axiosInstance.get('/v1/tags');

      dispatch({
        type: GET_ALL_TAGS,
        payload: res.data.data,
      });
    } catch (error: any) {
      return {
        error: true,
        message: error!?.response!?.data!?.message
          ? error!?.response!?.data!?.message
          : error!?.message || 'something went wrong',
      };
    }
  };

export const addSingleTag =
  (payload: { name: string }) =>
  async (dispatch: Dispatch<{ type: string; payload: any }>) => {
    try {
      const res = await axiosInstance.post('/v1/tags', payload);
      dispatch({
        type: GET_ALL_TAGS,
        payload: res.data.data,
      });
    } catch (error: any) {
      return {
        error: true,
        message: error!?.response!?.data!?.message
          ? error!?.response!?.data!?.message
          : error!?.message || 'something went wrong',
      };
    }
  };
